import transferOrderDetailApi from '@/api/apiList/inventoryTransferApi'
const transferOrderDetail = {
  state: {
    detail: {},// 库存转移详情
    boxList: [],// 箱子列表
  },
  getters: {
  },
  mutations: {
    // 库存转移-设置详情
    setDetail(state, data) {
      state.detail = data
    },
    // 库存转移-设置箱子列表
    setBoxList(state, data) {
      state.boxList = data
    },

  },
  actions: {
    // 库存转移-获取详情
    moveDetail({ commit }, data) {
      transferOrderDetailApi.moveDetail(data).then(res => {
        res.data.list.forEach(item => {
          item.checked = false
        })
        commit('setDetail', res.data)
      })
    },
    // 库存转移-获取箱子列表
    transferOrdeBoxList({ commit }, data) {
      transferOrderDetailApi.boxList(data).then(res => {
        res.data.forEach(item => {
          item.checked = false
          item.list.forEach(box => {
            box.checked = false
          })
        })
        commit('setBoxList', res.data)
      })
    },



  },
};

export default transferOrderDetail;